module.exports = __webpack_public_path__ + "img/targetOn.96fd8514.svg";